import { sceneryTile as tile, type WorldBackdrop } from './worldShapeKit';

/** Ruins have open arches (single concave polygons, no unsupported SVG holes);
 * sky realms keep genuinely floating islands rather than ground-filled peaks. */
export const OTHERWORLD_BACKDROPS = {
  ruins: {
    far: tile('shelf', [['ruin', 130, 340, 460, 320], ['ruin', 1260, 340, 520, 300]]),
    mid: tile('crags', [['column', 590, 345, 150, 320], ['ruin', 1540, 350, 340, 275]]),
    near: tile('crags', [['basalt', 420, 335, 300, 151], ['column', 1980, 340, 140, 197]]),
  },
  cave: {
    far: tile('crags', [['crystal', 210, 350, 580, 330], ['crystal', 1430, 349, 420, 294]]),
    mid: tile('crags', [['crystal', 780, 349, 350, 311], ['basalt', 1830, 346, 310, 249]]),
    near: tile('crags', [['crystal', 260, 344, 260, 234], ['crystal', 1380, 342, 220, 188]]),
  },
  roots: {
    far: tile('crags', [['snag', 170, 350, 380, 330], ['snag', 1280, 350, 460, 324]]),
    mid: tile('banks', [['willow', 610, 340, 490, 321], ['mushroom', 1720, 340, 245, 198]]),
    near: tile('banks', [['snag', 310, 340, 260, 262], ['mushroom', 1280, 340, 190, 174]]),
  },
  fungal: {
    far: tile('hills', [['mushroom', 150, 325, 410, 287], ['mushroom', 1300, 339, 480, 307]]),
    mid: tile('banks', [['mushroom', 650, 334, 400, 318], ['mushroom', 1730, 340, 285, 244]]),
    near: tile('banks', [['mushroom', 270, 329, 200, 167], ['mushroom', 1190, 334, 250, 226]]),
  },
  fossil: {
    far: tile('crags', [['mesa', 230, 340, 540, 284], ['mesa', 1590, 348, 470, 245]]),
    mid: tile('banks', [['ribs', 260, 345, 420, 288], ['ribs', 1320, 341, 440, 260]]),
    near: tile('crags', [['ribs', 790, 342, 250, 210], ['basalt', 1840, 339, 230, 120]]),
  },
  petrified: {
    far: tile('crags', [['mesa', 290, 341, 590, 298], ['obelisk', 1590, 333, 230, 272]]),
    mid: tile('crags', [['snag', 180, 339, 230, 310], ['snag', 1170, 340, 330, 296], ['column', 1950, 337, 130, 215]]),
    near: tile('crags', [['snag', 540, 342, 200, 217], ['basalt', 1570, 340, 265, 136]]),
  },
  sky: {
    far: tile(null, [['island', 170, 255, 550, 215], ['island', 1290, 317, 640, 230]]),
    mid: tile(null, [['island', 470, 324, 490, 265], ['island', 1690, 375, 420, 237]]),
    near: tile(null, [['island', 120, 340, 330, 167], ['island', 1290, 391, 510, 266]]),
  },
  celestial: {
    far: tile(null, [['island', 150, 260, 530, 200], ['obelisk', 350, 99, 55, 83], ['island', 1530, 340, 460, 211]]),
    mid: tile(null, [['island', 850, 349, 560, 276], ['ruin', 1000, 134, 190, 122]]),
    near: tile(null, [['island', 190, 390, 490, 266], ['obelisk', 370, 182, 65, 127]]),
  },
  volcanic: {
    far: tile('crags', [['volcano', 160, 350, 850, 334], ['volcano', 1340, 349, 690, 256]]),
    mid: tile('crags', [['basalt', 430, 338, 410, 260], ['basalt', 1670, 342, 360, 276]]),
    near: tile('crags', [['basalt', 980, 341, 290, 189], ['crystal', 1960, 337, 170, 163]]),
  },
  corrupted: {
    far: tile('crags', [['obelisk', 240, 337, 170, 306], ['snag', 1390, 341, 310, 280]]),
    mid: tile('crags', [['snag', 620, 342, 340, 324], ['crystal', 1800, 340, 210, 249]]),
    near: tile('crags', [['crystal', 330, 340, 230, 201], ['snag', 1280, 340, 190, 222]]),
  },
  abyss: {
    far: tile(null, [['obelisk', 170, 394, 290, 380], ['obelisk', 1230, 396, 340, 338]]),
    mid: tile(null, [['crystal', 560, 399, 360, 339], ['obelisk', 1800, 399, 230, 375]]),
    near: tile('crags', [['crystal', 150, 355, 290, 260], ['obelisk', 1260, 360, 220, 283]]),
  },
} satisfies Record<string, WorldBackdrop>;
